module.exports = __webpack_public_path__ + "img/medium.33caa195.svg";